// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1SlcW","buttons":"PendingPaymentAlert_buttons__1Xnuv"};